import {NewPasswordForm} from 'components/template/NewPasswordForm'

export const NewPassword = () => {
  return (
    <div className="text-gray-800 flex flex-col justify-center items-center">
      <NewPasswordForm />
    </div>
  )
}
